export const getActionsForConsideration = (
  targetPayGap: number | string | null,
  t?: (key: string, options?: Record<string, unknown>) => string,
) => [
  {
    label: t ? t('pe.costPlanning.actions.removeSignificance') : 'Remove statistical significance',
    value: 'REMOVESIGNIFICANT',
    name: 'Remove statistical significance',
  },
  {
    label: t
      ? t('pe.costPlanning.actions.setAdjustedPayGapTo', { targetPayGap: targetPayGap ?? 0 })
      : `Set adjusted pay gap to ${targetPayGap ?? 0}%`,
    value: 'ADJUSTEDGAPZERO',
    name: `Set adjusted pay gap to ${targetPayGap ?? 0}%`,
  },
  {
    label: t
      ? t('pe.costPlanning.actions.customizePayAdjustments')
      : 'Customize pay adjustments',
    value: 'CUSTOM',
    name: 'Customize pay adjustments',
  },
];

export enum ModelName {
  INITIAL = 'INITIAL',
  REMOVESIGNIFICANT = 'REMOVESIGNIFICANT',
  ADJUSTEDGAPZERO = 'ADJUSTEDGAPZERO',
  CUSTOM = 'CUSTOM',
}

export enum ReportSource {
  WORKDAY = 'workday',
}

export const totalCost = 'TOTAL';

export enum CostAdjustmentStandardDeviation {
  useStandardDeviation = 'standard_deviation',
  adjustedPayGap = 'adjusted_pay_gap',
}

export enum CostAdjustmentFields {
  maxThreshold = 'maxThreshold',
  minThreshold = 'minThreshold',
  raiseAmount = 'raiseAmount',
  selectGroup = 'selectGroup',
}

export const employeePayGapTablecolumnConfigs = [
  { id: 'check_box', labelKey: '', width: '50px' },
  { id: 'employee_id', labelKey: 'pe.employeeid', width: '100px' },
  { id: 'name', labelKey: 'pe.name', width: '100px' },
  { id: 'job_title', labelKey: 'pe.jobtitle', width: '130px' },
  { id: 'gender', labelKey: 'pe.gender', width: '100px' },
  { id: 'race', labelKey: 'pe.race', width: '120px' },
  { id: 'job_level_grade', labelKey: 'pe.level', width: '100px' },
  { id: 'current_pay', labelKey: 'pe.currentpay', width: '170px' },
  {
    id: 'predicted_pay',
    labelKey: 'pe.expectedpay',
    width: '160px',
    tooltip: 'pe.costPlanning.expectedPayTooltip',
    isSpecialLabel: true,
  },
  { id: 'adjusted_pay_gap', labelKey: 'pe.adjustedpaygap', width: '230px'},
  { id: 'standared_deviation', labelKey: 'pe.standareddeviation', width: '170px' },
];

// Grouped headers for Year 1 and Year 2
export const yearColumnGroups = [
  {
    groupId: 'year_1',
    groupLabel: 'pe.year1',
    backgroundColor: '#F4F3F3',
    colspan: 2,
    subColumns: [
      { id: 'proposed_pay_adjustment', labelKey: 'pe.proposedpayadjustment', width: '230px' },
      { id: 'new_pay', labelKey: 'pe.newpay', width: '100px' },
    ]
  },
  {
    groupId: 'year_2', 
    groupLabel: 'pe.year2',
    backgroundColor: '#F4F3F3',
    colspan: 2,
    subColumns: [
      { id: 'proposed_pay_adjustment_year_2', labelKey: 'pe.proposedpayadjustment', width: '230px' },
      { id: 'new_pay_year_2', labelKey: 'pe.newpay', width: '100px' },
    ]
  }
];

// Complete column list for data mapping
export const allTableColumns = [
  ...employeePayGapTablecolumnConfigs,
  ...yearColumnGroups.flatMap(group => group.subColumns)
];
